import React from 'react'

import {
  LaunchStrategyRecommendation,
  useLaunchStrategyContext,
} from '@modules/Dashboard/modules/LaunchStrategy'

import type { Recommendation } from '../../../Recommendations.types'
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss'

export const useLaunchStrategyRecommendation = () => {
  const { createOnDismiss } = useRecommendationsDismiss()
  const {
    data: launchStrategyData,
    visible: launchStrategyVisible,
    openModal: openLaunchStrategyModal,
    onDismiss: onLaunchStrategyDismiss,
  } = useLaunchStrategyContext()

  return {
    launchStrategyRecommendation: {
      id: 'launchStrategy' as const,
      enabled: launchStrategyVisible,

      isLoading: false,
      suggestion: (
        <LaunchStrategyRecommendation
          {...launchStrategyData.recommendation}
          onClick={openLaunchStrategyModal}
          onDismiss={createOnDismiss(onLaunchStrategyDismiss)}
        />
      ),
    } satisfies Recommendation,
  }
}
